module.exports = __webpack_public_path__ + "img/slovakia.6757a9c3.svg";